import { useAuth0 } from '@auth0/auth0-react';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import PreSchoolService from 'Lib/API/PreSchool';
import FinanceSetting from 'Lib/API/FinanceSetting/FinanceSetting';
import MainModal from 'components/MainModal/MainModal';
import MyButton from 'components/MyButton';
import { FormikWizard } from 'formik-wizard-form';
import { formatDate } from 'helper/dateFormat';
import { uploadFile } from 'pages/Auth/Presigned';
import React, { useEffect, useRef, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { useHistory, useParams } from 'react-router-dom';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import { emailValidation, urlValidation } from 'utils/validation';
import {
  eventInformation,
  eventPricing,
} from '../../ValidationSchema/eventSchema';
import './event.scss';
import { getMovedSavedDates, isRegisteredOnDate } from './multiDateChanges';
import CreateForm from './newEventSteps/CreateForm/CreateForm';
import EventInformation from './newEventSteps/EventInformation/EventInformation';
import NotificationTemplate from './newEventSteps/NotificationTemplate/NotificationTemplate';
import Pricing from './newEventSteps/Pricing/Pricing';

const CreateNewEvent = () => {
  const orgDetails = getOrganizationInfoFromLocalStorage();

  const [finished, setFinished] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [coverImage, setCoverImage] = useState("");
  const [croppedImage, setCroppedImage] = useState(null);
  // { values, dates } while waiting for the user to confirm moving dates that have registrations
  const [dateChangeConfirm, setDateChangeConfirm] = useState(null);
  const { push } = useHistory();
  const { id: eventId } = useParams();
  const formikRef = useRef();

  const requiredFields = [
    {
      "id": "93EF4F7B-E69F-4DC7-94BE-BB5B1793FE88",
      "element": "TextInput",
      "text": "Text Input",
      "required": true,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "text_input_DC6632D8-F02F-4ED2-AC46-351DB7B949A4",
      "label": "First Name ",
      "dirty": false
    },
    {
      "id": "869CA6BE-DE41-48CB-89B4-2FC0D9862FC5",
      "element": "TextInput",
      "text": "Text Input",
      "required": true,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "text_input_D00A65F9-01A9-4FA8-A132-01E7EF6F8984",
      "label": "Last Name ",
      "dirty": false
    },
    {
      "id": "986AB1B0-19F0-4339-8594-59427982B41D",
      "element": "EmailInput",
      "text": "Email",
      "required": true,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
      "label": "E-Mail"
    },
    {
      "id": "1E0C45B6-1876-49CC-9FD2-7CF124B14B3C",
      "element": "PhoneNumber",
      "text": "Phone Number",
      "required": false,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "phone_input_03841728-EC2E-4965-9B3B-623FABE57B6E",
      "label": "Phone Number"
  }
    
  ]
  const requiredFieldsIds = [
    "93EF4F7B-E69F-4DC7-94BE-BB5B1793FE88",
    "869CA6BE-DE41-48CB-89B4-2FC0D9862FC5",
    "986AB1B0-19F0-4339-8594-59427982B41D",
    "1E0C45B6-1876-49CC-9FD2-7CF124B14B3C"
  ]
  const defaultPrices = [
    {
      title: 'Ticket',
      amount: '',
      type: 'Tickets',
      ledger: {},
      subLedger: {},
      tax_deductible: '',
      tax_type: '$',
      chargeDate: '',
      dueDate: '',
      note: '',
      is_splitted: false,
      // variant_label: '',
      variant: false,
      quantity: '',
      infiniteQuantity: false,
      limitType: 'amount',
      variantInfo: [
        {
          name: '',
          quantity: '',
          infiniteQuantity: false,
          reserveProduct: 0,
          amount: '',
          forMemberOnly: false,
        }
      ],
    },
];
  useEffect(() => {
    if (eventId) {
      const getEvent = async () => {
        try {
          if (formikRef.current) {
            formikRef.current.setFieldValue('loading', true);
          }
          const token = await getAccessTokenSilently();
          const response = await PreSchoolService.getEventById(token, eventId);
          const data = response?.result;
          const eventInfo = {
            id: data?._id,
            eventName: data?.eventName,
            date: data?.date,
            multiDateEvent: data?.multiEvents || false,
            registrationType: data?.multiEventsType === 'grouped' ? 'group' : data?.multiEventsType === 'individual' ? 'individual' : '',
            dateLabel: data?.multiEventsDates?.[0]?.label || '',
            // saved dates remember their original value/label so a moved date (and its registrations) can be detected on save
            originalDate: data?.multiEvents ? data?.multiEventsDates?.[0]?.eventDate : undefined,
            originalDateLabel: data?.multiEventsDates?.[0]?.label || '',
            additionalEventDates: (data?.multiEventsDates || []).slice(1).map(d => ({ date: d.eventDate, eventDuration: d.eventDuration, label: d.label || '', originalDate: d.eventDate, originalLabel: d.label || '' })),
            displayOnly: data?.displayOnly || false,
            hadParticipants: data?.hadParticipants || false,
            eventDuration: data?.eventDuration?.value ? data?.eventDuration : { key: '30 min', value: 30 },
            eventStartDate: data?.eventStartDate,
            eventEndDate: data?.eventEndDate,
            description: data?.description?.replace(/&lt;/g, '<'),
            allowWaitingList: data?.allowWaitingList,
            allowBillMyAccount: data?.allowBillMyAccount,
            allowNonMembers: !orgDetails?.memberPortal ? true :data?.allowNonMembers,
            eventDetails: {
              maximumCapacity: !data?.eventDetails?.infiniteCapacity ? data?.eventDetails?.maximumCapacity ?? '' : '',
              infiniteCapacity: data?.eventDetails?.infiniteCapacity ?? true,
              eventType: data?.eventDetails?.eventType,
              eventAddress: data?.eventDetails?.eventAddress || {},
              eventLink: data?.eventDetails?.eventLink ?? '',
              contactInfo: {
                firstName: data?.eventDetails?.contactInfo?.firstName ?? '',
                lastName: data?.eventDetails?.contactInfo?.lastName ?? '',
                email: data?.eventDetails?.contactInfo?.email ?? '',
                showEmail: data?.eventDetails?.contactInfo?.showEmail ?? false,
                facebook: data?.eventDetails?.contactInfo?.facebook ?? '',
                instagram: data?.eventDetails?.contactInfo?.instagram ?? '',
                twitter: data?.eventDetails?.contactInfo?.twitter ?? '',
              },
              tags: data?.eventDetails?.tags || [],
              accountTags: data?.eventDetails?.accountTags || [],
              actionButtonLabel: data?.buttonLabel || 'Start',
            },
            prices: data?.eventPricing?.prices?.map((item) => {
              const hasVariantData =
                item?.variantInfo &&
                typeof item.variantInfo === 'object' &&
                !Array.isArray(item.variantInfo) &&
                Object.keys(item.variantInfo).length > 0;
              const hasVariant = item?.variant || hasVariantData;
              return {
                ...item,
                limitType: item?.limitType || 'amount',
                variant: hasVariant || false,
                variantInfo: hasVariant ? transformVariantInfoToArray(item?.variantInfo) : [],
                quantity: item?.quantity ?? '',
                infiniteQuantity: item?.infiniteQuantity ?? false,
                minimumOpenAmount: item?.minimumOpenAmount ?? '',
                type:
                  item?.type === 'optional'
                    ? 'Addons'
                    : item?.type === 'onRegistration'
                      ? 'Tickets'
                      : item?.type === 'noPayment'
                      ? 'No Payment Needed'
                      : item?.type === 'openAmount'
                      ? 'Open Amount'
                      : 'On Approve',
              };
            }),
            discount: data?.eventDiscount,
            formId: data?.form,
            requiredFelids: required_form_field,
            step1Active: 'generalInfo',
            step2Active: 'costInfo',
            step3Active: 'Templates',
            background: data?.background,
            freeEvent: data?.freeEvent ?? false,
            fillTemplate: data?.fillTemplate || '',
            billMyAccountTemplate: data?.billMyAccountTemplate || '',
            emailNotification: data?.emailNotification || [],
            requiredFormFields: requiredFields,
            requiredFieldsIds: requiredFieldsIds,
          };
          setCroppedImage(data?.background);
          if (formikRef.current) {
            formikRef.current.setValues(eventInfo);
          }
        } catch (error) {
          toastr.error('Error', 'Something went wrong');
        } finally {
          if (formikRef.current) {
            formikRef.current.setFieldValue('loading', false);
          }
        }
      };
      getEvent();
    }
  }, [eventId, getAccessTokenSilently]);

  const transformVariantInfoToObject = (variantInfo, type, isIndividual = false) => {
    const newVariantInfo = {};
    variantInfo.forEach((item) => {
      let key;
      if (item?.isMultiDateVariant || (isIndividual && item?.userAddedVariant)) {
        const sanitize = (s) => String(s).replace(/[^a-zA-Z0-9]/g, '');
        const datePart = String(new Date(item.eventDate).getTime());
        const parts = [datePart, item.dateLabel, item.name].filter(Boolean).map(p => sanitize(String(p)));
        key = `__mde_${parts.join('_')}__`;
      } else {
        key = item?.name;
      }
      newVariantInfo[key] = {
        ...(item?.infiniteQuantity ? {
          infiniteQuantity: item?.infiniteQuantity,
          reserveProduct: type === "update" ? +item?.reserveProduct || 0 : undefined,
          amount: +item?.amount,
          forMemberOnly: item?.forMemberOnly,
          openAmount: item?.openAmount || false,
        } : {
          quantity: +item?.quantity,
          reserveProduct: type === "update" ? +item?.reserveProduct || 0 : undefined,
          amount: +item?.amount,
          forMemberOnly: item?.forMemberOnly,
          openAmount: item?.openAmount || false,
        }),
        ...(item?.eventDate ? { eventDate: item.eventDate } : {}),
        ...(item?.dateLabel ? { dateLabel: item.dateLabel } : {}),
        ...(item?.isMultiDateVariant ? { isMultiDateVariant: true, ...(item?.name ? { variantLabel: item.name } : {}) } : {}),
        ...(item?.userAddedVariant ? { userAddedVariant: true, ...(item?.name ? { variantLabel: item.name } : {}) } : {}),
      }
    })
    return newVariantInfo;
  }
  const transformVariantInfoToArray = (variantInfo) => {
    const newVariantInfo = [];
    if (!variantInfo || Object.keys(variantInfo).length === 0) return newVariantInfo;
    const extractNameFromKey = (key, eventDate, dateLabel) => {
      const sanitize = (s) => String(s).replace(/[^a-zA-Z0-9]/g, '');
      const datePart = eventDate ? String(new Date(eventDate).getTime()) : '';
      const knownParts = [datePart, dateLabel].filter(Boolean).map(p => sanitize(String(p)));
      const prefix = `__mde_${knownParts.join('_')}_`;
      if (key.startsWith(prefix) && key.endsWith('__')) {
        return key.slice(prefix.length, -2);
      }
      return '';
    };
    for (const key in variantInfo) {
      const v = variantInfo[key];
      newVariantInfo.push({
        name: key.startsWith('__mde_') ? (v?.variantLabel || extractNameFromKey(key, v?.eventDate, v?.dateLabel)) : key,
        quantity: v?.quantity || "",
        infiniteQuantity: v?.infiniteQuantity || false,
        reserveProduct: v?.reserveProduct || 0,
        amount: v?.amount,
        forMemberOnly: v?.forMemberOnly || false,
        openAmount: v?.openAmount || false,
        ...(v?.eventDate ? { eventDate: v.eventDate } : {}),
        ...(v?.dateLabel ? { dateLabel: v.dateLabel } : {}),
        ...(v?.isMultiDateVariant ? { isMultiDateVariant: true } : {}),
        ...(v?.userAddedVariant ? { userAddedVariant: true, requiresEventDate: true } : (v?.eventDate && !v?.isMultiDateVariant ? { requiresEventDate: true } : {})),
      });
    }
    return newVariantInfo;
  }

  const fetchTemplatePayload = async (id) => {
    if (!id) return undefined;
    try {
      const token = await getAccessTokenSilently();
      const res = await FinanceSetting.getTemplateById(token, id);
      const r = res?.result;
      if (!r) return undefined;
      return { htmlContent: r.htmlContent, jsonContent: r.jsonContent, replyTo: r.replyTo ?? null, useDefault: r.useDefault ?? true, subject: r.subject };
    } catch (_) { return undefined; }
  };

  const resolveTemplatePayloads = async (values) => {
    const [fill, bill] = await Promise.all([
      values?.fillTemplatePayload || fetchTemplatePayload(values?.fillTemplate),
      values?.billMyAccountTemplatePayload || fetchTemplatePayload(values?.billMyAccountTemplate),
    ]);
    return { fill, bill };
  };

  const handleCreateEvent = async (values) => {
    const { fill: fillTemplatePayload, bill: billMyAccountTemplatePayload } = await resolveTemplatePayloads(values);
    const isDisplayOnly = values?.displayOnly || false;
    const data = {
      eventName: values?.eventName,
      multiEvents: values?.multiDateEvent || false,
      multiEventsDates: values?.multiDateEvent
        ? [
            { eventDate: values?.date, eventDuration: values?.eventDuration, ...(values?.dateLabel ? { label: values.dateLabel } : {}) },
            ...(values?.additionalEventDates || []).map(d => ({ eventDate: d.date, eventDuration: d.eventDuration, ...(d.label ? { label: d.label } : {}) })),
          ]
        : [],
      ...(!isDisplayOnly && values?.multiDateEvent ? { multiEventsType: values?.registrationType === 'group' ? 'grouped' : 'individual' } : {}),
      displayOnly: isDisplayOnly,
      ...(!isDisplayOnly ? { buttonLabel: values?.eventDetails?.actionButtonLabel } : {}),
      date: values?.date,
      eventDuration: values?.eventDuration,
      ...(!isDisplayOnly ? { eventStartDate: values?.eventStartDate } : {}),
      ...(!isDisplayOnly ? { eventEndDate: values?.eventEndDate } : {}),
      description: values?.description,
      ...(!isDisplayOnly ? { allowWaitingList: values?.allowWaitingList } : {}),
      ...(!isDisplayOnly ? { allowBillMyAccount: values?.allowBillMyAccount } : {}),
      ...(!isDisplayOnly ? { allowNonMembers: values?.allowNonMembers } : {}),
      eventDetails: {
        ...(!isDisplayOnly && !values?.eventDetails?.infiniteCapacity ? { maximumCapacity: values?.eventDetails?.maximumCapacity } : {}),
        ...(!isDisplayOnly ? { infiniteCapacity: values?.eventDetails?.infiniteCapacity } : {}),
        ...(!isDisplayOnly && values?.eventDetails?.infiniteCapacity ? { infiniteCapacity: true } : {}),
        eventType: values?.eventDetails?.eventType,
        eventAddress: values?.eventDetails?.eventAddress,
        eventLink: values?.eventDetails?.eventLink,
        contactInfo: {
          firstName: values?.eventDetails?.contactInfo?.firstName,
          lastName: values?.eventDetails?.contactInfo?.lastName,
          email: values?.eventDetails?.contactInfo?.email,
          showEmail: values?.eventDetails?.contactInfo?.showEmail || false,
          facebook:  values?.eventDetails?.contactInfo?.facebook,
          instagram: values?.eventDetails?.contactInfo?.instagram,
          twitter: values?.eventDetails?.contactInfo?.twitter,
        },
        tags: values?.eventDetails?.tags,
        accountTags: values?.eventDetails?.accountTags || [],
      },
      ...(!isDisplayOnly ? {
        eventPricing: {
          prices: values.freeEvent ? [] : values?.prices?.map((item) => ({
            ...item,
            amount: (item?.type === 'Addons' && item?.variant ) || (item?.type === 'Tickets' && item?.variant) || (item?.type === 'No Payment Needed') || item?.type === 'Open Amount' ? undefined : item?.amount,
            type:
            item?.type === 'Addons' ? 'optional' : item?.type === 'Tickets'
                ? 'onRegistration'
                : item?.type === 'No Payment Needed'
                ? 'noPayment'
                : item?.type === 'Open Amount'
                ? 'openAmount'
                : 'onApprove',
            ledger: item?.type === 'No Payment Needed' ? undefined : item?.ledger,
            subLedger:
              item?.type === 'No Payment Needed' ? undefined : item?.subLedger,
            tax_deductible: item?.tax_deductible
              ? +item?.tax_deductible
              : undefined,
            chargeDate:
              item?.type === 'On Approve'  ? item?.chargeDate : undefined,
            dueDate: item?.type === 'On Approve' ? item?.dueDate : undefined,
            note: item?.note ? item?.note : undefined,
            split_duration: item?.is_splitted && item?.split_duration ? item?.split_duration : undefined,
            number_of_split: item?.is_splitted && item?.number_of_split ? item?.number_of_split : undefined,
            required_notes: undefined,
            isRequired: item?.type === "Addons" ? item?.isRequired : undefined,
            variant: (item?.type === "Addons" || item?.type === "Tickets") ? item?.variant : undefined,
            quantity: (item?.type === "Open Amount" && !item?.infiniteQuantity) ? item?.quantity :
                      ((item?.type === "Addons") && (!item?.infiniteQuantity && item?.limitType === 'amount') && !item?.variant) ? item?.quantity : undefined,
            infiniteQuantity: item?.type === "Open Amount" ? item?.infiniteQuantity :
                              ((item?.type === "Addons") && !item?.variant) ? item?.infiniteQuantity : undefined,
            limitType: item?.type === "Addons" ? item?.limitType ? item?.limitType : 'amount' : undefined,
            minimumOpenAmount: item?.type === "Open Amount" ? +item?.minimumOpenAmount || undefined : undefined,
            minAmount: undefined,
            isRecurring: undefined,
            variantInfo: (item?.type === "Tickets" || item?.type === "Addons") && item?.variantInfo?.length && item?.variant ? transformVariantInfoToObject(item?.variantInfo, "create", !!(values?.multiDateEvent && values?.registrationType === 'individual')) : undefined,
          })),
        },
        eventDiscount: values.freeEvent ? [] : values?.discount?.map((item) => ({
          discount_name: item?.discount_name,
          discount_type:
            item?.discount_type === 'Date'
              ? 'date'
              : item?.discount_type === 'Amount'
              ? 'amount'
              : 'quantity',
          price_type: item?.price_type,
          value: item?.value,
          start_date:
            item?.discount_type === 'Date' ? item?.start_date : undefined,
          end_date: item?.discount_type === 'Date' ? item?.end_date : undefined,
          amount: item?.amount,
          quantity: item?.quantity,
          forMemberOnly: item?.forMemberOnly,
        })),
        form: values?.formId,
        freeEvent: values?.freeEvent,
        fillTemplatePayload: fillTemplatePayload || undefined,
        billMyAccountTemplatePayload: billMyAccountTemplatePayload || undefined,
        emailNotification: values?.emailNotification || [],
      } : {}),
    };
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const newUrl = coverImage
      ? await uploadFile(coverImage, coverImage, token)
      : "";
      if (typeof newUrl.fileName === "string") {
        data.background = newUrl.fileName;
      }
      await PreSchoolService.createEvent(token, data);
      toastr.success('Success', 'Event created successfully');
      push('/newEvents');
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const validationUrl = (url) => {
    let valid = true;
    if(url && !urlValidation(url)) {
      valid = false;
    }
    return valid;
  }


  const handleUpdateEvent = async (values) => {
    const { fill: fillTemplatePayload, bill: billMyAccountTemplatePayload } = await resolveTemplatePayloads(values);
    const isDisplayOnly = values?.displayOnly || false;
    const data = {
      eventName: values?.eventName,
      multiEvents: values?.multiDateEvent || false,
      multiEventsDates: values?.multiDateEvent
        ? [
            { eventDate: values?.date, eventDuration: values?.eventDuration, ...(values?.dateLabel ? { label: values.dateLabel } : {}) },
            ...(values?.additionalEventDates || []).map(d => ({ eventDate: d.date, eventDuration: d.eventDuration, ...(d.label ? { label: d.label } : {}) })),
          ]
        : [],
      ...(!isDisplayOnly && values?.multiDateEvent ? { multiEventsType: values?.registrationType === 'group' ? 'grouped' : 'individual' } : {}),
      displayOnly: isDisplayOnly,
      ...(!isDisplayOnly ? { buttonLabel: values?.eventDetails?.actionButtonLabel } : {}),
      date: values?.date,
      eventDuration: values?.eventDuration,
      ...(!isDisplayOnly ? { eventStartDate: values?.eventStartDate } : {}),
      ...(!isDisplayOnly ? { eventEndDate: values?.eventEndDate } : {}),
      description: values?.description,
      ...(!isDisplayOnly ? { allowWaitingList: values?.allowWaitingList } : {}),
      ...(!isDisplayOnly ? { allowBillMyAccount: values?.allowBillMyAccount } : {}),
      ...(!isDisplayOnly ? { allowNonMembers: values?.allowNonMembers } : {}),
      eventDetails: {
        ...(!isDisplayOnly && !values?.eventDetails?.infiniteCapacity ? { maximumCapacity: values?.eventDetails?.maximumCapacity } : {}),
        ...(!isDisplayOnly ? { infiniteCapacity: values?.eventDetails?.infiniteCapacity } : {}),
        ...(!isDisplayOnly && values?.eventDetails?.infiniteCapacity ? { infiniteCapacity: true } : {}),
        eventType: values?.eventDetails?.eventType,
        eventAddress: values?.eventDetails?.eventAddress,
        eventLink: values?.eventDetails?.eventLink,
        contactInfo: {
          firstName: values?.eventDetails?.contactInfo?.firstName,
          lastName: values?.eventDetails?.contactInfo?.lastName,
          email: values?.eventDetails?.contactInfo?.email,
          showEmail: values?.eventDetails?.contactInfo?.showEmail || false,
          facebook:  values?.eventDetails?.contactInfo?.facebook,
          instagram: values?.eventDetails?.contactInfo?.instagram,
          twitter: values?.eventDetails?.contactInfo?.twitter,
        },
        tags: values?.eventDetails?.tags,
        accountTags: values?.eventDetails?.accountTags || [],
      },
      ...(!isDisplayOnly ? {
        eventPricing: {
          prices: values.freeEvent ? [] : values?.prices?.map((item) => ({
            ...item,
            amount: (item?.type === 'Addons' && item?.variant ) || (item?.type === 'Tickets' && item?.variant) || (item?.type === 'No Payment Needed') || item?.type === 'Open Amount' ? undefined : item?.amount,
            type:
            item?.type === 'Addons' ? 'optional' : item?.type === 'Tickets'
                ? 'onRegistration'
                : item?.type === 'No Payment Needed'
                ? 'noPayment'
                : item?.type === 'Open Amount'
                ? 'openAmount'
                : 'onApprove',
            ledger: item?.type === 'No Payment Needed' ? undefined : item?.ledger,
            subLedger:
              item?.type === 'No Payment Needed' ? undefined : item?.subLedger,
            tax_deductible: item?.tax_deductible
              ? +item?.tax_deductible
              : undefined,
            chargeDate:
              item?.type === 'On Approve' ? item?.chargeDate : undefined,
            dueDate: item?.type === 'On Approve' ? item?.dueDate : undefined,
            note: item?.note ? item?.note : undefined,
            _id: undefined,
            split_duration: item?.is_splitted && item?.split_duration ? item?.split_duration : undefined,
            number_of_split: item?.is_splitted && item?.number_of_split ? item?.number_of_split : undefined,
            required_notes: undefined,
            isRequired: item?.type === "Addons" ? item?.isRequired : undefined,
            variant: (item?.type === "Addons" || item?.type === "Tickets") ? item?.variant : undefined,
            quantity: (item?.type === "Open Amount" && !item?.infiniteQuantity) ? item?.quantity :
                      ((item?.type === "Addons") && (!item?.infiniteQuantity && item?.limitType === 'amount') && !item?.variant) ? item?.quantity : undefined,
            infiniteQuantity: item?.type === "Open Amount" ? item?.infiniteQuantity :
                              ((item?.type === "Addons") && !item?.variant) ? item?.infiniteQuantity : undefined,
            limitType: item?.type === "Addons" ? item?.limitType ? item?.limitType : 'amount' : undefined,
            minimumOpenAmount: item?.type === "Open Amount" ? +item?.minimumOpenAmount || undefined : undefined,
            minAmount: undefined,
            isRecurring: undefined,
            variantInfo: (item?.type === "Tickets" || item?.type === "Addons") && item?.variantInfo?.length && item?.variant ? transformVariantInfoToObject(item?.variantInfo, "update", !!(values?.multiDateEvent && values?.registrationType === 'individual')) : undefined,
          })),
        },
        eventDiscount: values.freeEvent ? [] : values?.discount?.map((item) => ({
          discount_name: item?.discount_name,
          discount_type:
            item?.discount_type === 'Date' || item?.discount_type === 'date'
              ? 'date'
              : item?.discount_type === 'Amount' ||
                item?.discount_type === 'amount'
              ? 'amount'
              : 'quantity',
          price_type: item?.price_type,
          value: item?.value,
          start_date:
            item?.discount_type === 'Date' || item?.discount_type === 'date'
              ? item?.start_date
              : undefined,
          end_date:
            item?.discount_type === 'Date' || item?.discount_type === 'date'
              ? item?.end_date
              : undefined,
          amount: item?.amount,
          quantity: item?.quantity,
          forMemberOnly: item?.forMemberOnly,
        })),
        form: values?.formId,
        freeEvent: values?.freeEvent,
        fillTemplatePayload: fillTemplatePayload || undefined,
        billMyAccountTemplatePayload: billMyAccountTemplatePayload || undefined,
        emailNotification: values?.emailNotification || [],
      } : {}),
    };
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const newUrl = coverImage
      ? await uploadFile(coverImage, coverImage, token)
      : "";
      if (typeof newUrl.fileName === "string") {
        data.background = newUrl.fileName;
      }
      await PreSchoolService.updateEvent(token, data, eventId);
      toastr.success('Success', 'Event updated successfully');
      push('/newEvents');
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  // Moved saved dates that already have registrations, with how many people are registered on each.
  // `count` is null when the participants couldn't be loaded (the change is still warned about).
  const getMovedDatesWithRegistrations = async (values) => {
    const moved = getMovedSavedDates(values);
    if (!moved.length || !values?.hadParticipants) return [];
    try {
      const token = await getAccessTokenSilently();
      const PAGE_SIZE = 100;
      const first = await PreSchoolService.getEventParticipants(token, 1, PAGE_SIZE, { eventId });
      const total = first?.payload?.pagination?.count || 0;
      // grouped registrations always cover every date
      if (values?.registrationType === 'group') {
        return total ? moved.map((date) => ({ ...date, count: total })) : [];
      }
      let participants = first?.payload?.data || [];
      for (let page = 2; participants.length < total && page <= Math.ceil(total / PAGE_SIZE); page++) {
        const next = await PreSchoolService.getEventParticipants(token, page, PAGE_SIZE, { eventId });
        participants = participants.concat(next?.payload?.data || []);
      }
      return moved
        .map((date) => ({ ...date, count: participants.filter((p) => isRegisteredOnDate(p, date)).length }))
        .filter((date) => date.count > 0);
    } catch (error) {
      return moved.map((date) => ({ ...date, count: null }));
    }
  };

  // Saving an edited event: if a saved date that people registered for was moved, confirm first.
  const handleSaveEvent = async (values) => {
    if (!eventId) {
      handleCreateEvent(values);
      return;
    }
    setLoading(true);
    const movedWithRegistrations = await getMovedDatesWithRegistrations(values);
    setLoading(false);
    if (movedWithRegistrations.length) {
      setDateChangeConfirm({ values, dates: movedWithRegistrations });
      return;
    }
    handleUpdateEvent(values);
  };




  const handleNextStep = async (values, currentStepIndex, handleNext) => {
    if (currentStepIndex === 0) {
      const errors = await formikRef.current.validateForm();
      const isDisplayOnly = formikRef.current.values?.displayOnly;
      // Manual check for registrationType since Yup `when` may not propagate in all versions
      if (!isDisplayOnly && formikRef.current.values?.multiDateEvent && !formikRef.current.values?.registrationType) {
        errors.registrationType = 'Required';
      }
      // For displayOnly, clear fields that aren't shown
      if (isDisplayOnly) {
        delete errors.eventStartDate;
        delete errors.eventEndDate;
        delete errors.registrationType;
        if (errors.eventDetails) {
          delete errors.eventDetails.actionButtonLabel;
          if (Object.keys(errors.eventDetails.contactInfo || {}).length === 0) delete errors.eventDetails.contactInfo;
          if (Object.keys(errors.eventDetails).length === 0) delete errors.eventDetails;
        }
      }
      // Multi-date event: validate that all additional date rows have date and duration filled
      const isMultiDate = formikRef.current.values?.multiDateEvent;
      if (isMultiDate) {
        // Validate primary date label
        if (!formikRef.current.values?.dateLabel) {
          errors.dateLabel = 'Required';
        }
        const additionalDates = formikRef.current.values?.additionalEventDates || [];
        additionalDates.forEach((entry, i) => {
          if (!entry.date) {
            if (!errors.additionalEventDates) errors.additionalEventDates = [];
            if (!errors.additionalEventDates[i]) errors.additionalEventDates[i] = {};
            errors.additionalEventDates[i].date = 'Required';
          }
          if (!entry.eventDuration?.key) {
            if (!errors.additionalEventDates) errors.additionalEventDates = [];
            if (!errors.additionalEventDates[i]) errors.additionalEventDates[i] = {};
            errors.additionalEventDates[i].eventDuration = 'Required';
          }
          if (!entry.label) {
            if (!errors.additionalEventDates) errors.additionalEventDates = [];
            if (!errors.additionalEventDates[i]) errors.additionalEventDates[i] = {};
            errors.additionalEventDates[i].label = 'Required';
          }
        });
      }
      // Manual duplicate label check using actual values
      if (isMultiDate) {
        const primaryLabel = formikRef.current.values?.dateLabel?.trim().toLowerCase();
        const additionalLabels = (formikRef.current.values?.additionalEventDates || []).map(d => d?.label?.trim().toLowerCase());
        const allLabels = [primaryLabel, ...additionalLabels];
        const seen = new Set();
        allLabels.forEach((label, idx) => {
          if (!label) return;
          if (seen.has(label)) {
            // mark the duplicate — find all indices with this label
            if (idx === 0) {
              errors.dateLabel = 'Label already used';
            } else {
              if (!errors.additionalEventDates) errors.additionalEventDates = [];
              if (!errors.additionalEventDates[idx - 1]) errors.additionalEventDates[idx - 1] = {};
              errors.additionalEventDates[idx - 1].label = 'Label already used';
            }
            // also mark the first occurrence
            const firstIdx = allLabels.indexOf(label);
            if (firstIdx === 0) {
              errors.dateLabel = 'Label already used';
            } else {
              if (!errors.additionalEventDates) errors.additionalEventDates = [];
              if (!errors.additionalEventDates[firstIdx - 1]) errors.additionalEventDates[firstIdx - 1] = {};
              errors.additionalEventDates[firstIdx - 1].label = 'Label already used';
            }
          } else {
            seen.add(label);
          }
        });
      }
      const hasDuplicateLabels =
        errors.dateLabel === 'Label already used' ||
        (Array.isArray(errors.additionalEventDates) &&
          errors.additionalEventDates.some(e => e?.label === 'Label already used'));
      if (hasDuplicateLabels) {
        const newTouched = { ...formikRef.current.touched };
        if (errors.dateLabel) newTouched.dateLabel = true;
        if (Array.isArray(errors.additionalEventDates)) {
          newTouched.additionalEventDates = errors.additionalEventDates.map((e, i) => ({
            ...(formikRef.current.touched?.additionalEventDates?.[i] || {}),
            ...(e?.label ? { label: true } : {}),
          }));
        }
        formikRef.current.setErrors(errors);
        formikRef.current.setTouched(newTouched, false);
        toastr.error('Validation', 'Labels cannot be the same for multi-date events');
        return;
      }
      if (Object.keys(errors).length > 0) {
        const newTouched = { ...formikRef.current.touched };
        if (errors.eventName) newTouched.eventName = true;
        if (errors.date) newTouched.date = true;
        if (errors.eventDuration) newTouched.eventDuration = { key: true, value: true };
        if (!isDisplayOnly && errors.eventStartDate) newTouched.eventStartDate = true;
        if (!isDisplayOnly && errors.eventEndDate) newTouched.eventEndDate = true;
        if (!isDisplayOnly && errors.registrationType) newTouched.registrationType = true;
        if (errors.eventDetails) {
          newTouched.eventDetails = { ...(formikRef.current.touched?.eventDetails || {}) };
          if (!isDisplayOnly && errors.eventDetails.actionButtonLabel) newTouched.eventDetails.actionButtonLabel = true;
          if (!isDisplayOnly && errors.eventDetails.maximumCapacity) newTouched.eventDetails.maximumCapacity = true;
          if (errors.eventDetails.contactInfo?.email) newTouched.eventDetails.contactInfo = { email: true };
        }
        if (errors.dateLabel) newTouched.dateLabel = true;
        if (errors.additionalEventDates) {
          newTouched.additionalEventDates = (errors.additionalEventDates || []).map((e, i) => ({
            ...(formikRef.current.touched?.additionalEventDates?.[i] || {}),
            ...(e?.date ? { date: true } : {}),
            ...(e?.eventDuration ? { eventDuration: true } : {}),
            ...(e?.label ? { label: true } : {}),
          }));
        }
        formikRef.current.setErrors(errors);
        formikRef.current.setTouched(newTouched, false);
        const missing = [];
        if (errors.eventName) missing.push('Event Name');
        if (errors.date) missing.push('Date');
        if (errors.eventDuration) missing.push('Event Duration');
        if (!isDisplayOnly && errors.registrationType) missing.push('Registration Type');
        if (!isDisplayOnly && errors.eventStartDate) missing.push('Start Time');
        if (!isDisplayOnly && errors.eventEndDate) missing.push('Registration End Date');
        if (!isDisplayOnly && errors.eventDetails?.actionButtonLabel) missing.push('Action Button Label');
        if (!isDisplayOnly && errors.eventDetails?.maximumCapacity) missing.push('Maximum Capacity');
        if (errors.eventDetails?.contactInfo?.email) missing.push('Email');
        if (errors.additionalEventDates?.some(e => e?.date)) missing.push('Event Date/Hour');
        if (errors.additionalEventDates?.some(e => e?.eventDuration)) missing.push('Event Duration');
        if (errors.dateLabel || errors.additionalEventDates?.some(e => e?.label)) missing.push('Label');
        const hasMultiDateErrors = !!(errors.additionalEventDates || errors.dateLabel);
        toastr.info(
          'Validation',
          hasMultiDateErrors
            ? `At least 2 event dates are required for multi-date event. Please fill: ${[...new Set(missing)].join(', ')}`
            : missing.length > 0
            ? `Please fill the following required fields: ${missing.join(', ')}`
            : 'Please fill all the mandatory fields'
        );
        return;
      }
      if (!validationUrl(values?.eventDetails?.contactInfo?.facebook) || !validationUrl(values?.eventDetails?.contactInfo?.instagram) || !validationUrl(values?.eventDetails?.contactInfo?.twitter)) {
        toastr.info('Validation', 'Please enter valid url');
        return;
      }
      if (formikRef.current.values?.multiDateEvent) {
        const allRows = [
          { date: formikRef.current.values.date, durationMinutes: formikRef.current.values.eventDuration?.value },
          ...(formikRef.current.values.additionalEventDates || []).map(d => ({ date: d.date, durationMinutes: d.eventDuration?.value })),
        ];
        for (let i = 0; i < allRows.length - 1; i++) {
          const { date, durationMinutes } = allRows[i];
          const nextDate = allRows[i + 1].date;
          if (date && durationMinutes && nextDate) {
            const endTime = new Date(new Date(date).getTime() + durationMinutes * 60 * 1000);
            if (endTime > new Date(nextDate)) {
              toastr.error('Validation', 'Event dates cannot overlap');
              return;
            }
          }
        }
      }
    }

    if (currentStepIndex === 1) {
      const errors = await formikRef.current.validateForm();
      // Manually inject variantInfo.amount errors for Tickets/Addons (Yup 0.29 may not propagate them)
      if (!values.freeEvent) {
        (values.prices || []).forEach((price, i) => {
          if ((price.type === 'Tickets' || price.type === 'Addons') && price.variant && Array.isArray(price.variantInfo)) {
            price.variantInfo.forEach((item, vi) => {
              const amount = item?.amount;
              if (amount === '' || amount === undefined || amount === null) {
                if (!errors.prices) errors.prices = [];
                if (!errors.prices[i]) errors.prices[i] = {};
                if (!errors.prices[i].variantInfo) errors.prices[i].variantInfo = [];
                if (!errors.prices[i].variantInfo[vi]) errors.prices[i].variantInfo[vi] = {};
                errors.prices[i].variantInfo[vi].amount = 'Required';
              }
            });
          }
        });
      }
      const isIndividualMultiDate = values?.multiDateEvent && values?.registrationType === 'individual';
      // Inject duplicate variant name errors (per-date for individual multi-date events)
      (values.prices || []).forEach((price, i) => {
        if (price.variant && Array.isArray(price.variantInfo)) {
          const seen = {};
          price.variantInfo.forEach((item, vi) => {
            const name = item?.name?.trim().toLowerCase();
            if (!name) return;
            // For individual multi-date, names only need to be unique within the same date
            const seenKey = isIndividualMultiDate ? `${String(item.eventDate)}_${name}` : name;
            if (seen[seenKey] !== undefined) {
              [seen[seenKey], vi].forEach((dupVi) => {
                if (!errors.prices) errors.prices = [];
                if (!errors.prices[i]) errors.prices[i] = {};
                if (!errors.prices[i].variantInfo) errors.prices[i].variantInfo = [];
                if (!errors.prices[i].variantInfo[dupVi]) errors.prices[i].variantInfo[dupVi] = {};
                errors.prices[i].variantInfo[dupVi].name = 'Variant name already used';
              });
            } else {
              seen[seenKey] = vi;
            }
          });
        }
      });
      // Clear name errors for isMultiDateVariant rows that have no user-added variant for the same date
      if (isIndividualMultiDate) {
        (values.prices || []).forEach((price, i) => {
          if (price.type === 'Tickets' && price.variant && Array.isArray(price.variantInfo)) {
            price.variantInfo.forEach((item, vi) => {
              if (item?.isMultiDateVariant) {
                const hasManualForDate = price.variantInfo.some(
                  v => !v.isMultiDateVariant && String(v.eventDate) === String(item.eventDate)
                );
                if (!hasManualForDate && errors.prices?.[i]?.variantInfo?.[vi]?.name) {
                  delete errors.prices[i].variantInfo[vi].name;
                  if (!Object.keys(errors.prices[i].variantInfo[vi]).length) {
                    errors.prices[i].variantInfo[vi] = undefined;
                  }
                }
              }
            });
            // Clean up variantInfo array if all entries are now gone
            if (errors.prices?.[i]?.variantInfo) {
              const hasRemainingVariantErrors = errors.prices[i].variantInfo.some(
                e => e != null && Object.keys(e).length > 0
              );
              if (!hasRemainingVariantErrors) {
                delete errors.prices[i].variantInfo;
                if (!Object.keys(errors.prices[i]).length) {
                  errors.prices[i] = undefined;
                }
              }
            }
          }
        });
      }
      // Check for duplicate discount names
      const discounts = values?.discount || [];
      if (discounts.length > 1) {
        const discountNames = discounts.map(d => d?.discount_name?.trim()?.toLowerCase()).filter(Boolean);
        const hasDuplicateDiscountNames = discountNames.some((name, i) => discountNames.indexOf(name) !== i);
        if (hasDuplicateDiscountNames) {
          const newTouched = { ...formikRef.current.touched };
          newTouched.discount = discounts.map((_, i) => ({
            ...(formikRef.current.touched?.discount?.[i] || {}),
            discount_name: true,
          }));
          formikRef.current.setTouched(newTouched);
          if (!errors.discount) errors.discount = [];
          discounts.forEach((d, i) => {
            const name = d?.discount_name?.trim()?.toLowerCase();
            if (name && discountNames.filter(n => n === name).length > 1) {
              if (!errors.discount[i]) errors.discount[i] = {};
              errors.discount[i].discount_name = 'Discount name already exists';
            }
          });
          formikRef.current.setErrors(errors);
          toastr.info('Validation', 'Discount names must be unique');
          return;
        }
      }

      // Group multidate: if open to non-members, ticket variants must have at least one non-member variant
      const isGroupMultiDate = values?.multiDateEvent && values?.registrationType === 'group';
      if (isGroupMultiDate && values?.allowNonMembers) {
        const ticketPrice = (values.prices || []).find(p => p.type === 'Tickets');
        if (ticketPrice?.variant && Array.isArray(ticketPrice.variantInfo) && ticketPrice.variantInfo.length > 0) {
          const hasNonMemberVariant = ticketPrice.variantInfo.some(v => !v.forMemberOnly);
          if (!hasNonMemberVariant) {
            toastr.info('Validation', 'Since "Open to Non-Members" is checked, at least one ticket variant must not be members only.');
            return;
          }
        }
      }

      const hasPriceErrors = Array.isArray(errors?.prices) && errors.prices.some((e) => e && Object.keys(e).length > 0);
      const hasDiscountErrors = Array.isArray(errors?.discount) && errors.discount.some((e) => e && Object.keys(e).length > 0);
      if (hasPriceErrors || hasDiscountErrors) {
        const newTouched = { ...formikRef.current.touched };
        if (hasPriceErrors) {
          newTouched.prices = values.prices.map((price, i) => {
            const existing = formikRef.current.touched?.prices?.[i] || {};
            if (price.type === 'No Payment Needed') return existing;
            const quantityTouched = !(price.type === 'Addons' && price.limitType === 'checkbox');
            const fields = { ...existing, amount: true, quantity: quantityTouched, minimumOpenAmount: true, ledger: true };
            if (price.isInstallmentTransaction) fields.installmentDetailsTransaction = { numberOfInstallment: true };
            if (price.variant && Array.isArray(price.variantInfo)) {
              fields.variantInfo = price.variantInfo.map((item, vi) => ({
                ...(formikRef.current.touched?.prices?.[i]?.variantInfo?.[vi] || {}),
                name: true, amount: true, quantity: true,
                ...(item?.requiresEventDate ? { eventDate: true } : {}),
              }));
            }
            return fields;
          });
        }
        if (hasDiscountErrors) {
          newTouched.discount = (values.discount || []).map((_, i) => ({
            ...(formikRef.current.touched?.discount?.[i] || {}),
            discount_name: true, discount_type: true, price_type: true,
            value: true, amount: true, quantity: true,
            start_date: true, end_date: true,
          }));
        }
        formikRef.current.setTouched(newTouched);
        const missing = [];
        if (Array.isArray(errors.prices)) {
          errors.prices.forEach((priceErr, i) => {
            if (!priceErr) return;
            const priceTitle = values.prices?.[i]?.title || `Price ${i + 1}`;
            if (priceErr.amount) missing.push(`${priceTitle} - Amount`);
            if (priceErr.quantity) missing.push(`${priceTitle} - Quantity`);
            if (priceErr.minimumOpenAmount) missing.push(`${priceTitle} - Min Amount`);
            if (priceErr.ledger) missing.push(`${priceTitle} - Ledger`);
            if (priceErr.installmentDetailsTransaction?.numberOfInstallment) missing.push(`${priceTitle} - Installments`);
            if (Array.isArray(priceErr.variantInfo)) {
              priceErr.variantInfo.forEach((varErr, vi) => {
                if (!varErr) return;
                const varLabel = values.prices?.[i]?.variantInfo?.[vi]?.name || `Variant ${vi + 1}`;
                if (varErr.name) missing.push(`${priceTitle} - Variant ${vi + 1} Name${varErr.name !== 'Required' ? ` (${varErr.name})` : ''}`);
                if (varErr.eventDate) missing.push(`${priceTitle} - ${varLabel} - Select Date`);
                if (varErr.amount) missing.push(`${priceTitle} - ${varLabel} - Amount`);
                if (varErr.quantity) missing.push(`${priceTitle} - ${varLabel} - Quantity`);
              });
            }
          });
        }
        if (Array.isArray(errors.discount)) {
          errors.discount.forEach((discErr, i) => {
            if (!discErr) return;
            const discLabel = values.discount?.[i]?.discount_name || `Discount ${i + 1}`;
            if (discErr.discount_name) missing.push(`${discLabel} - Name`);
            if (discErr.discount_type) missing.push(`${discLabel} - Type`);
            if (discErr.price_type) missing.push(`${discLabel} - Price Type`);
            if (discErr.value) missing.push(`${discLabel} - Value`);
            if (discErr.amount) missing.push(`${discLabel} - Amount`);
            if (discErr.quantity) missing.push(`${discLabel} - Quantity`);
            if (discErr.start_date) missing.push(`${discLabel} - Start Date`);
            if (discErr.end_date) missing.push(`${discLabel} - End Date`);
          });
        }
        toastr.info(
          'Validation',
          missing.length > 0
            ? `Please fill the following required fields: ${missing.join(', ')}`
            : 'Please fill all the mandatory fields'
        );
        return;
      }

      if (!values?.freeEvent) {
        const isTicketTypeExist = values?.prices?.some((item) => item?.type === 'Tickets');
        if (!isTicketTypeExist) {
          toastr.info('Validation', 'Please add ticket type');
          return;
        }
        for (const price of values?.prices) {
          const variantsRequiringName = (price?.variantInfo || []).filter(v => {
            if (!v?.isMultiDateVariant) return true;
            if (!(isIndividualMultiDate && price.type === 'Tickets')) return true;
            // isMultiDateVariant row only needs a name when there's a user-added variant for the same date
            return price.variantInfo.some(u => !u.isMultiDateVariant && String(u.eventDate) === String(v.eventDate));
          });
          if (price?.variant && (!price?.variantInfo?.length || variantsRequiringName.some(v => !v?.name?.trim()))) {
            const newTouched = { ...formikRef.current.touched };
            newTouched.prices = values.prices.map((p, idx) => ({
              ...(formikRef.current.touched?.prices?.[idx] || {}),
              variantInfo: (p.variantInfo || []).map((_, vi) => ({
                ...(formikRef.current.touched?.prices?.[idx]?.variantInfo?.[vi] || {}),
                name: true, amount: true, quantity: true,
              })),
            }));
            formikRef.current.setTouched(newTouched);
            toastr.info('Validation', `${price?.title || 'Price'} - Please fill all variant details`);
            return;
          }
          if (!price?.type) {
            return toastr.info('Validation', 'Please select payment type');
          } else if (price.type === 'Tickets') {
            const maxVariants = isIndividualMultiDate ? 104 : 10;
            if (price?.variant && price?.variantInfo?.length > maxVariants) {
              toastr.info('Validation', `You can add maximum ${maxVariants} variants`);
              return;
            }
            if (price?.variant && price?.variantInfo?.length) {
              const namesByDate = {};
              for (const item of price?.variantInfo) {
                // Skip isMultiDateVariant rows with no user-added variant for the same date
                if (item?.isMultiDateVariant && isIndividualMultiDate) {
                  const hasManualForDate = price.variantInfo.some(
                    v => !v.isMultiDateVariant && String(v.eventDate) === String(item.eventDate)
                  );
                  if (!hasManualForDate) continue;
                }
                if (!values?.eventDetails?.infiniteCapacity && !item?.infiniteQuantity && item?.quantity > values?.eventDetails?.maximumCapacity) {
                  toastr.info('Validation', 'quantity should be less than maximum capacity');
                  return;
                }
                // For individual multi-date, names only need to be unique within the same date
                const nameKey = isIndividualMultiDate ? String(item.eventDate) : '__global__';
                if (!namesByDate[nameKey]) namesByDate[nameKey] = new Set();
                if (namesByDate[nameKey].has(item?.name?.trim())) {
                  toastr.info('Validation', 'Please enter unique variant name');
                  return;
                }
                namesByDate[nameKey].add(item?.name?.trim());
              }
            }
          } else if (price.type === 'Addons') {
            if (price?.variant && price?.variantInfo?.length) {
              const names = new Set();
              for (const item of price?.variantInfo) {
                if (names.has(item?.name?.trim())) {
                  toastr.info('Validation', 'Please enter unique variant name');
                  return;
                }
                names.add(item?.name?.trim());
              }
            }
          }
          if (price?.isInstallmentTransaction && !price?.installmentDetailsTransaction?.numberOfInstallment) {
            toastr.info('Validation', 'Please select number of installments');
            return;
          }
        }
        for (const discount of values?.discount) {
          if (discount.discount_type?.toLowerCase() === 'amount') {
            if (!discount?.amount || discount?.amount < 1) {
              toastr.info('Validation', 'Discount amount should be greater than or equal 1');
              return;
            }
          } else if (discount.discount_type?.toLowerCase() === 'quantity') {
            if (!discount?.quantity || discount?.quantity < 1) {
              toastr.info('Validation', 'Discount quantity should be greater than or equal 1');
              return;
            }
          }
        }
      }
    }

    if (currentStepIndex === 0 && values?.displayOnly) {
      handleSaveEvent(values);
      return;
    }

    if (currentStepIndex === 3) {
      handleSaveEvent(values);
    }
    handleNext();
  };






  const required_form_field = [
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: true,
      element: 'TextInput',
      field_name: 'text_input_06108B97-D7AC-42A5-8167-ECB948331A10',
      group_name: undefined,
      id: '93EF4F7B-E69F-4DC7-94BE-BB5B1793FE88',
      inline: undefined,
      label: 'First Name ',
      required: true,
      showDescription: undefined,
      static: undefined,
      text: 'Text Input',
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      element: 'TextInput',
      field_name: 'text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143',
      group_name: undefined,
      id: '869CA6BE-DE41-48CB-89B4-2FC0D9862FC5',
      inline: undefined,
      label: 'Last Name ',
      required: true,
      showDescription: undefined,
      static: undefined,
      text: 'Text Input',
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      showDescription: undefined,
      static: undefined,
      id: "986AB1B0-19F0-4339-8594-59427982B41D",
      element: "EmailInput",
      text: "Email",
      field_name: "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
      label: "E-Mail"
      
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      isRequired: false,
      showDescription: undefined,
      static: undefined,
      id: "1E0C45B6-1876-49CC-9FD2-7CF124B14B3C",
      element: "PhoneNumber",
      text: "Phone Number",
      field_name: "phone_input_03841728-EC2E-4965-9B3B-623FABE57B6E",
      label: "Phone Number"
    },
    
  ];
  const initialValues = {
    eventName: '',
    date: '',
    multiDateEvent: false,
    dateLabel: '',
    additionalEventDates: [],
    registrationType: '',
    displayOnly: false,
    hadParticipants: false,
    eventDuration: {
      key: '30 min',
      value: 30,
    },
    eventStartDate: '',
    eventEndDate: '',
    description: '',
    allowWaitingList: false,
    allowBillMyAccount: false,
    allowNonMembers: true,
    eventDetails: {
      maximumCapacity: '',
      infiniteCapacity: true,
      eventType: 'In-Person',
      eventAddress: {},
      eventLink: '',
      contactInfo: {
        firstName: '',
        lastName: '',
        email: '',
        showEmail: false,
        facebook: '',
        instagram: '',
        twitter: '',
      },
      tags: [],
      accountTags: [],
      actionButtonLabel: 'Start',
    },
    prices: [
      {
        title: 'Ticket',
        amount: '',
        type: 'Tickets',
        ledger: {},
        subLedger: {},
        tax_deductible: '',
        tax_type: '$',
        chargeDate: '',
        dueDate: '',
        note: '',
        is_splitted: false,
        // variant_label: '',
        variant: false,
        quantity: '',
        minimumOpenAmount: '',
        infiniteQuantity: false,
        limitType: 'amount',
        variantInfo: [
          {
            name: '',
            quantity: '',
            infiniteQuantity: true,
            reserveProduct: 0,
            amount: '',
            forMemberOnly: false,
          }
        ],
      },
    ],
    discount: [],
    discount_value_type: 'fixed_price',
    discount_type: '',
    internalDrawer: {},
    form_name: '',
    save_template_toggle: 'no',
    form: {},
    requiredFelids: required_form_field,
    formId: '',
    step1Active: 'generalInfo',
    step2Active: 'costInfo',
    step3Active: 'Templates',
    background: "",
    freeEvent: false,
    fillTemplate: '',
    billMyAccountTemplate: '',
    emailNotification: [],
    requiredFormFields: requiredFields,
    requiredFieldsIds: requiredFieldsIds,
  };



  return (
    <div className="class__container create-event__container">
      <FormikWizard
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={(values) => {}}
        validateOnBlur={true}
        steps={[
          {
            component: (props) => <EventInformation coverImage={coverImage}
              setCoverImage={setCoverImage}
              setCroppedImage={setCroppedImage}
              croppedImage={croppedImage}
            {...props} />,
            validationSchema: eventInformation,
          },
          {
            component: Pricing,
            validationSchema: eventPricing,
          },
          {
            component: CreateForm,
          },
          {
            component: NotificationTemplate,
          },
        ]}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          currentStepIndex,
          renderComponent,
          handlePrev,
          handleNext,
          isNextDisabled,
          isPrevDisabled,
          handleSubmit,
          ...props
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="top_section">
              <div className="header__title">{eventId ? "Edit Event" : "New Event"}</div>
              <div className="class__steps">
                <Stepper activeStep={currentStepIndex}>
                  <Step completed={currentStepIndex > 0} className="step">
                    <StepLabel className="step-label">
                      Event Information
                    </StepLabel>
                  </Step>
                  {!values?.displayOnly && <Step completed={currentStepIndex > 1}>
                    <StepLabel>Pricing</StepLabel>
                  </Step>}
                  {!values?.displayOnly && <Step completed={currentStepIndex > 2}>
                    <StepLabel>Create Form</StepLabel>
                  </Step>}
                  {!values?.displayOnly && <Step completed={currentStepIndex > 3}>
                    <StepLabel>Notifications</StepLabel>
                  </Step>}
                </Stepper>
              </div>
              <div className="action__section">
                <div className="action__buttons d-flex">
                  <MyButton
                    content={currentStepIndex === 0 ? 'Cancel' : 'Previous'}
                    onClick={() => {
                      if (currentStepIndex === 0) {
                        push('/newEvents');
                      }  else {
                        handlePrev();
                      }
                    }}
                    style={{
                      marginRight: '1rem',
                      borderRadius: '0',
                      color: '#565656',
                      height: '39px',
                      width: '113px',
                      backgroundColor: '#fff',
                    }}
                  />
                  <MyButton
                    content={
                      currentStepIndex === 3 || (currentStepIndex === 0 && values?.displayOnly) ? (
                        <span>
                          Save
                          {loading && (
                            <span className="ml-3 spinner spinner-gray"></span>
                          )}
                        </span>
                      ) : (
                        'Continue'
                      )
                    }
                    onClick={() =>
                      handleNextStep(values, currentStepIndex, handleNext)
                    }
                    disabled={loading}
                    style={{
                      width: '121px',
                      height: '36px',
                    }}
                  />
                </div>
              </div>
            </div>
            <Box>{renderComponent()}</Box>
          </form>
        )}
      </FormikWizard>
      <MainModal
        open={!!dateChangeConfirm}
        title="Change dates with registrations?"
        description={
          <>
            {(dateChangeConfirm?.dates || []).map((date, i) => (
              <span key={i} style={{ display: 'block', marginBottom: '6px' }}>
                <strong>{date.label || 'Event date'}</strong>:{' '}
                {formatDate({ date: date.from, formatType: 'defaultWithTimeUTC' })} &rarr;{' '}
                {formatDate({ date: date.to, formatType: 'defaultWithTimeUTC' })}
                {date.count !== null
                  ? ` (${date.count} ${date.count === 1 ? 'registration' : 'registrations'})`
                  : ' (has registrations)'}
              </span>
            ))}
            <span style={{ display: 'block', marginTop: '10px' }}>
              People already registered stay registered for {dateChangeConfirm?.dates?.length > 1 ? 'these dates' : 'this date'} and will move to the new date and time.
            </span>
          </>
        }
        acceptBtnText="Change dates"
        loading={loading}
        onDecline={() => setDateChangeConfirm(null)}
        onAccept={() => {
          const { values } = dateChangeConfirm;
          setDateChangeConfirm(null);
          handleUpdateEvent(values);
        }}
      />
    </div>
  );
};

export default CreateNewEvent;
